import React, { useState } from 'react';
import { useApolloClient, gql } from '@apollo/client';

const useSetApolloCache = (railsContext: any) => {
  const apolloClient = useApolloClient();
  const [loaded, setLoaded] = useState(false);

  React.useLayoutEffect(() => {
    const {
      organization,
      currentUser,
      isPreviewingWebsite,
      ebEnv,
    } = railsContext;
    apolloClient.writeQuery({
      query: gql`
        query {
          ebEnv
          userIsPreviewing
          currentOrganization {
            id
            hasSubscription
            name
            pricingVersion
          }
          currentUser {
            id
            name
            email
            role
            organizations {
              id
            }
          }
        }
      `,
      data: {
        ebEnv,
        userIsPreviewing: isPreviewingWebsite,
        currentOrganization: organization
          ? {
              id: organization.id.toString(),
              hasSubscription: organization.has_subscription,
              name: organization.name,
              pricingVersion: organization.pricing_version,
              __typename: 'Organization',
            }
          : null,
        currentUser: currentUser
          ? {
              id: currentUser.id.toString(),
              name: currentUser.name,
              email: currentUser.email,
              role: currentUser.role,
              organizations: currentUser.organization_ids.map(id => ({
                id: id.toString(),
                __typename: 'Organization',
              })),
              __typename: 'User',
            }
          : null,
      },
    });

    setLoaded(true);
  }, []);
  return loaded;
};

export default useSetApolloCache;
